module.exports = __webpack_public_path__ + "static/media/logo180.9524d11c.png";